import { PackAndFocusEntityType } from 'enums';
import { PackPreviewType } from 'interfaces/initial-states.interface';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import { createHtml } from 'utils/helpers';

const PackPreviewTitle = ({
  previewType
}: {
  previewType: PackPreviewType;
}) => {
  const { currentViewedPack, currentViewedFocusTemplate } =
    useAppSelectorShallow((state) => ({
      currentViewedPack: state.habitPack.currentViewedPack,
      currentViewedFocusTemplate: state.focusMode.currentViewedFocusTemplate
    }));

  const isHabitPack = previewType === PackAndFocusEntityType.HABIT_PACK;
  const name = isHabitPack
    ? (currentViewedPack?.pack_name ?? '')
    : (currentViewedFocusTemplate?.name ?? '');
  const author = isHabitPack
    ? (currentViewedPack?.creator_name ?? '')
    : (currentViewedFocusTemplate?.author_name ?? '');
  const description = isHabitPack
    ? currentViewedPack?.description_plain_text ||
      currentViewedPack?.description ||
      ''
    : (currentViewedFocusTemplate?.description ?? '');

  return (
    <header className='w-full flex flex-col gap-1 pb-2'>
      <h2 className='~text-base/xl font-semibold capitalize text-gray-900 dark:text-white line-clamp-2 '>
        {name || t('market.view_more_details')}
        {author && (
          <p className='text-sm text-gray-600 dark:text-gray-300 inline-block ~ml-2/4'>
            {t('market.made_by')}
            <span className='font-semibold text-gray-900 dark:text-white'>
              {author}
            </span>
          </p>
        )}
      </h2>
      {description && (
        <p className='text-xs sm:text-sm text-gray-600 dark:text-gray-400 line-clamp-2 pt-1'>
          {createHtml(description)}
        </p>
      )}
    </header>
  );
};

export default PackPreviewTitle;
